// api-settings.js - Handles API configuration and settings

import { showNotification, updateNotification } from './utils.js';

// Define API settings with default values
let apiUrl = "https://data2.ppline.app:3102";
// let apiUrl = "http://127.0.0.1:3102";

let agentId = "alaric";
let contextMessageCount = 15;

/**
 * Sets up API settings UI and event listeners
 */
function setupAPISettings() {
    const settingsToggle = document.getElementById("settingsToggle");
    const apiSettingsModal = document.getElementById("apiSettingsModal");
    const closeSettings = document.getElementById("closeSettings");
    const apiUrlInput = document.getElementById("apiUrl");
    const agentIdInput = document.getElementById("agentId");
    const contextMessagesInput = document.getElementById("contextMessages");
    const saveSettingsBtn = document.getElementById("saveSettings");
    const testApiBtn = document.getElementById("testApiConnection");

    if (settingsToggle) {
        settingsToggle.addEventListener("click", toggleApiSettings);
    }

    if (closeSettings) {
        closeSettings.addEventListener("click", closeApiSettings);
    }

    if (saveSettingsBtn) {
        saveSettingsBtn.addEventListener("click", saveApiSettings);
    }

    if (testApiBtn) {
        testApiBtn.addEventListener("click", testApiConnection);
    }

    loadApiSettings();
}

/**
 * Loads API settings from localStorage
 */
function loadApiSettings() {
    const savedSettings = localStorage.getItem("alaricApiSettings");
    const apiUrlInput = document.getElementById("apiUrl");
    const agentIdInput = document.getElementById("agentId");
    const contextMessagesInput = document.getElementById("contextMessages");
    
    if (savedSettings) {
        const settings = JSON.parse(savedSettings);
        apiUrl = settings.apiUrl || apiUrl;
        agentId = settings.agentId || "alaric";
        contextMessageCount = settings.contextMessageCount || 5;

        if (apiUrlInput) apiUrlInput.value = apiUrl;
        if (agentIdInput) agentIdInput.value = agentId;
        if (contextMessagesInput) contextMessagesInput.value = contextMessageCount;
    } else {
        if (apiUrlInput) apiUrlInput.value = apiUrl;
        if (agentIdInput) agentIdInput.value = agentId;
        if (contextMessagesInput) contextMessagesInput.value = contextMessageCount;
    }
}

/**
 * Shows the API settings modal
 */
function toggleApiSettings() {
    const apiSettingsModal = document.getElementById("apiSettingsModal");
    if (apiSettingsModal) {
        apiSettingsModal.style.display = "flex";
    }
}

/**
 * Hides the API settings modal
 */
function closeApiSettings() {
    const apiSettingsModal = document.getElementById("apiSettingsModal");
    if (apiSettingsModal) {
        apiSettingsModal.style.display = "none";
    }
}

/**
 * Saves API settings to localStorage
 */
function saveApiSettings() {
    const apiUrlInput = document.getElementById("apiUrl");
    const agentIdInput = document.getElementById("agentId");
    const contextMessagesInput = document.getElementById("contextMessages");
    
    apiUrl = apiUrlInput.value.trim();
    agentId = agentIdInput.value.trim();
    contextMessageCount = parseInt(contextMessagesInput.value);

    localStorage.setItem(
        "alaricApiSettings",
        JSON.stringify({
            apiUrl,
            agentId,
            contextMessageCount,
        })
    );

    showNotification("API settings saved!", "success");
    closeApiSettings();
}

/**
 * Tests the API connection
 */
function testApiConnection() {
    const apiUrlInput = document.getElementById("apiUrl");
    const tempUrl = apiUrlInput.value.trim();

    const notification = showNotification("Testing API connection...", "info");

    fetch(`${tempUrl}/hello`)
        .then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                updateNotification(notification, `API test failed: ${response.status} ${response.statusText}`, "error");
                throw new Error(`HTTP error ${response.status}`);
            }
        })
        .then((data) => {
            if (data.agentId) {
                updateNotification(notification, "API test successful! Found Alaric agent.", "success");
            } else {
                updateNotification(notification, "API test successful, but Alaric agent not found.", "warning");
            }
        })
        .catch((error) => {
            updateNotification(notification, `API test failed: ${error.message}`, "error");
        });
}

/**
 * Verifies API connection and gets agent configuration
 * @returns {Promise<boolean>} Whether the connection was successful
 */
async function checkApiConnection() {
    try {
        const response = await fetch(`${apiUrl}/hello`);
        if (response.ok) {
            const data = await response.json();
            if (data.agentId) {
                agentId = data.agentId;
                
                const agentIdInput = document.getElementById("agentId"); 
                if (agentIdInput) {
                    agentIdInput.value = agentId;
                }
                
                localStorage.setItem(
                    "alaricApiSettings",
                    JSON.stringify({
                        apiUrl,
                        agentId,
                        contextMessageCount,
                    })
                );
            }
        }
        return true;
    } catch (error) {
        const notification = showNotification(
            `API connection failed: ${error.message}<br>Please contact support on Discord and disable your VPN`,
            "error"
        );
        
        setTimeout(() => {
            toggleApiSettings();
        }, 3000);
        
        return false;
    }
}

// Export functions and variables
export {
    apiUrl,
    agentId,
    contextMessageCount,
    setupAPISettings,
    loadApiSettings,
    toggleApiSettings,
    closeApiSettings,
    saveApiSettings,
    testApiConnection,
    checkApiConnection
};